import { DashboardTypes } from 'features/Codes'
import { DomainDefaultColumns } from 'features/dashboard/table/shared/Presets'
import { getPathAdAccountId } from 'utils'
import { ColumnIds } from '../../../Columns'

const storageKey = 'dashboardColumns'

export const getStorageItem = () =>
  JSON.parse(localStorage.getItem(storageKey)) || {}

export const getSavedColumns = () => {
  const storageItem = getStorageItem()
  const adAccountId = getPathAdAccountId()
  const accountColumns = storageItem[adAccountId] || {}
  ;[
    DashboardTypes.CAMPAIGN,
    DashboardTypes.AD_GROUP,
    DashboardTypes.KEYWORD,
    DashboardTypes.CREATIVE,
  ].forEach(key => {
    if (accountColumns[key] === undefined) {
      accountColumns[key] = {
        columns: DomainDefaultColumns[key],
      }
    } else {
      accountColumns[key].columns = accountColumns[key].columns.filter(
        columnId => ColumnIds.includes(columnId)
      )
    }
  })
  return accountColumns
}

export const persistColumns = (domainType, columns, id) => {
  const adAccountId = getPathAdAccountId()
  const storageItem = getStorageItem()
  const accountColumns = getSavedColumns()
  accountColumns[domainType] = {
    ...(id && { id }),
    columns,
  }
  storageItem[adAccountId] = accountColumns
  localStorage.setItem(storageKey, JSON.stringify(storageItem))
}
